/**https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript-react-plugin */

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin, AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { APPLICATION_INSIGHTS_INSTRUMENTATION_KEY } from "./config.json";

let appInsights: any = null;
let reactPlugin: any = null;
let browserHistory: any = null;

const initializeAppInsights = () => {
  //@ts-ignore
  browserHistory = createBrowserHistory({ basename: "" });
  reactPlugin = new ReactPlugin();
  appInsights = new ApplicationInsights({
    config: {
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
        // Add any other extension configs here
      },
      enableAutoRouteTracking: true,
      extensions: [reactPlugin],
      instrumentationKey:
        localStorage.getItem("appInsightsInstrumentationKey") ||
        APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
    },
  });
  appInsights.loadAppInsights();
};

export { initializeAppInsights, reactPlugin, appInsights, AppInsightsContext };
